import React, { createContext, useContext, useState, useEffect } from "react"
import { auth } from "../firebase"
import { onAuthStateChanged } from "firebase/auth"
import axios from "axios"
import GLOBAL from "../config/variable"

const UserContext = createContext()

export function UserProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [userData, setUserData] = useState(null)

  // Reusable function to fetch user data
  const fetchUserData = async (userInstance) => {
    try {
      const token = await userInstance.getIdToken()
      const response = await axios.get(
        `${GLOBAL.SERVER_URL}/users/${userInstance.uid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      setUserData(response.data.data)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        auth.signOut()
      }
      console.error("Error fetching user data:", error)
    }
  }

  // Function exposed to manually refetch user data
  const refetchUserData = async () => {
    if (user) {
      await fetchUserData(user)
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user)
      if (user) {
        await fetchUserData(user)
      } else {
        setUserData(null)
      }
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  const value = {
    user,
    setUser,
    loading,
    userData,
    setUserData,
    refetchUserData,
  }

  return (
    <UserContext.Provider value={value}>
      {!loading && children}
    </UserContext.Provider>
  )
}

export function useUserContext() {
  return useContext(UserContext)
}
